import React, {Component} from 'react';
import RedirectOnlyHome from "../common/RedirectOnlyHome";

class BookingWarning extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		return (<>
			<div className={'duration-warning text-center'} style={{padding:"0 5px", margin:"0 20px",border:"1px solid #d63545"}}>
				<h4 style={{color:"#d63545",backgroundColor:"#fff",margin:"0",fontSize:"16px"}}>Decreasing your booking length can help you save money on daily charges.</h4>
			</div>
		</>);
	}
}
export default BookingWarning;